import React from 'react';
import PSPDFKit from 'pspdfkit';
import Nodes from 'components/canvas/components/nodes';
import Canvas from 'components/canvas';
import FileUploadZone from './components/file-upload-zone';
import SideMenu from 'components/canvas/components/side-menu';
import PaintMenu, {
  ToolbarProvider,
} from 'components/canvas/components/paint-menu';
import MiniMap from 'components/canvas/components/mini-map';
import SideDrawer from 'components/canvas/components/side-drawer';
import NotificationSideDrawer from 'components/canvas/components/notification-side-drawer';
import TopLeftMenu from 'components/canvas/components/top-left-menu';
import TopRightMenu from 'components/canvas/components/top-right-menu';
import QuestionaireUI from 'components/canvas/components/questionaire-ui';
import RatingUI from 'components/canvas/components/rating-ui';
import IndicatorZoneMenu from 'routes/surface/components/indicator-zone-menu';
import SurfaceLinkContextMenu from 'routes/surface/components/surface-link-context-menu';
import ClipboardZoneIndicator from 'components/canvas/components/clipboard-zone-indicator';
import SurfaceNodeModals from 'routes/surface/components/surface-node-modals';
import GlobalLinkZoneIndicator from 'components/canvas/components/global-link-zone-indicator';
// import {
//   TextNodeModal,
//   TextSnippetNodeModal,
//   NoteNodeModal,
//   DocumentNodeModal,
//   ImageNodeModal,
//   ProtocolNodeModal,
//   RisSearchModal,
//   SurfaceNodeModal,
//   QuestionnaireNodeModal,
//   BackgroundNodeModal,
// } from 'routes/surface/style';
import LinkArrow from 'components/canvas/components/link-arrow';
import CollaboratingUsersCursors, {
  useCollaboratingCursorListeners,
} from 'routes/surface/components/collaborating-users-cursors';
import CanvasStart from 'routes/surface/components/canvas-start';
import SurfaceSubscriptionListeners from 'routes/surface/components/surface-subscriptions-listeners';
import useNodeSearchParams from 'routes/surface/hooks/use-node-search-params';
import { useSurfaceNodeModalsOperations } from 'routes/surface/hooks/use-surface-node-modals-context';
import { useHistory, useParams } from 'react-router-dom';
import { configuration } from 'components/pspdf';
import { Line } from 'react-konva';
import RiskUI from 'components/canvas/components/risk-ui';

function Surface() {
  const { id } = useParams<{ id: string }>();

  const history = useHistory();

  const { showNodeModal } = useSurfaceNodeModalsOperations();

  useNodeSearchParams(showNodeModal);

  useCollaboratingCursorListeners(id);

  React.useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      setTimeout(() => PSPDFKit.preloadWorker(configuration), 3000);
    }
  }, []);

  const navigateToSurface = React.useCallback((surfaceId: string) => {
    history.push('/surface/' + surfaceId);
  }, []);

  return (
    <>
      {/* // {isLoading === false && <SurfaceSubscriptionListeners surface={id} />}

      // <Canvas
      //   id={id}
      //   isLoading={isLoading}
      //   renderBelowCanvas={({ stage }) => (
      //     <>
      //       <TextNodeModal ref={modalRefs.textNodeModal} onHide={onModalHide} />

      //       <NoteNodeModal ref={modalRefs.noteNodeModal} onHide={onModalHide} />
      //       <TextSnippetNodeModal
      //         ref={modalRefs.textSnippetNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <DocumentNodeModal
      //         ref={modalRefs.documentNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <SurfaceNodeModal
      //         ref={modalRefs.surfaceNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <ProtocolNodeModal
      //         ref={modalRefs.protocolNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <BackgroundNodeModal ref={modalRefs.backgroundNodeModal} onHide={onModalHide} />
      //       <QuestionnaireNodeModal
      //         ref={modalRefs.questionnaireNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <ImageNodeModal
      //         ref={modalRefs.imageNodeModal}
      //         onHide={onModalHide}
      //       />
      //       <RisSearchModal
      //         ref={modalRefs.risSearchModal}
      //         onHide={onModalHide}
      //       />

      //       <TopLeftMenu />

      //       <TopRightMenu />

      //       <SideMenu
      //         stage={stage}
      //         showNodeModal={showNodeModal}
      //         modalTypeShown={modalTypeShown}
      //         surface={id}
      //       />

      //       <SideDrawer />

      //       <NotificationSideDrawer />

      //       <IndicatorZoneMenu>
      //         <GlobalLinkZoneIndicator />
      //         <ClipboardZoneIndicator />
      //       </IndicatorZoneMenu>

      //       {isLoading === false && (
      //         <MiniMap surface={id} nodes={nodes} isLoading={isLoading} />
      //       )}
      //       <SurfaceLinkContextMenu />
      //     </>
      //   )}>
      //   {() => {
      //     if (error) return null;
      //     console.log("XXX" , nodes)
      //     return (
      //       <>
      //         <Nodes
      //           surface={id}
      //           nodes={nodes.filter(n => n.__typename === "SurfaceBackgroundNode")}
      //           nodeEdges={nodeEdges}
      //           showNodeModal={showNodeModal}
      //           navigateToSurface={navigateToSurface}
      //         />
      //          <Nodes
      //           surface={id}
      //           nodes={nodes.filter(n => n.__typename !== "SurfaceBackgroundNode")}
      //           nodeEdges={nodeEdges}
      //           showNodeModal={showNodeModal}
      //           navigateToSurface={navigateToSurface}
      //         />
      //         <CollaboratingUsersCursors />
      //       </>
      //     );
      //   }} */}
      <ToolbarProvider>
        <SurfaceSubscriptionListeners surface={id} />
        <FileUploadZone surface={id}>
          <Canvas id={id}>
            <Nodes surface={id} navigateToSurface={navigateToSurface} />
            <LinkArrow surface={id} />
            <CollaboratingUsersCursors />
            <CanvasStart></CanvasStart>
          </Canvas>
        </FileUploadZone>
        <SurfaceNodeModals />

        <TopLeftMenu />

        <TopRightMenu />

        <QuestionaireUI surface={id} />

        <RatingUI surface={id} />

        <RiskUI surface={id} />

        <SideMenu surface={id} />

        <PaintMenu />

        <SideDrawer />

        <NotificationSideDrawer />

        <MiniMap surface={id} />
      </ToolbarProvider>
    </>
  );
}

export default Surface;
